import React from 'react';
import {observer} from 'mobx-react';
import {linoGirlScoutsAutographStore} from '../components/lino/lino-girl-scouts-autograph/lino-girl-scouts-autograph.store';
import {ProductCustomizationState} from './render.def';
// IMPORTANT: MUST NOT import from s.ts (product store) - this renderer code is used in multiple apps for image rendering

type Props = {
    pcs: ProductCustomizationState;
};

// Renders CustomizationMethodID = 0
export const FrameNone = observer(({pcs}: Props) => {
    return (
        <div id="frame-none-container">
            <div id="frame-none-container-inner">
                <img
                    id="frame-none"
                    className="img-core"
                    src={pcs.ProductID === 88937 ? linoGirlScoutsAutographStore.productImageUrl : `https://${pcs.CDNDomain}/images/products/full/${pcs.Image_Full.toLowerCase()}`}
                    alt={`Product Image of ${pcs.ProductName_Original}`}
                />

                {pcs.ProductTypeID === 5 && (
                    <div className="tassel-cord tassel-cord-0">
                        <picture>
                            <source
                                type="image/webp"
                                srcSet={`https://${pcs.CDNDomain}/images/cached/general/honor-cord1.webp`}
                            />
                            <img
                                width="128"
                                height="128"
                                src={`https://${pcs.CDNDomain}/images/cached/general/honor-cord1.png`}
                                alt="Frame Also Holds Cord"
                                loading="lazy"
                            />
                        </picture>
                    </div>
                )}
            </div>
        </div>
    );
});
